import { AfterViewInit, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from "../services/users.service";

@Component({
    selector: 'app-system',
    templateUrl: './system.component.html',
    styleUrls: ['./system.component.css'],
    standalone: false
})

export class SystemComponent implements AfterViewInit
{
    constructor(private translate: TranslateService, private usersService: UsersService)
    {  
        this.translate = translate;
    }

    ngAfterViewInit()
    {
        this.updateTitle();
        this.usersService.onInit.subscribe(() => { this.updateTitle(); });
        this.translate.onLangChange.subscribe(() => { this.updateTitle(); });
    }
    private updateTitle() {
        document.title = this.translate.instant(this.usersService.getTitle());
    }
}
